define('modules/form_editor/models/input_textarea',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  //Textarea Model
  //defaultValues get set on initialize as model attributes
  //We can't use "defaults" because those are defined
  //in the base model
  var BaseFormElement = require("./base_form_element");
  module.exports = BaseFormElement.extend({
    name: "input:textarea",
    defaultValues: {
      rows: 4
    }
  });
});
